export const getStarColorClass = (rating?: number) => {
  const rounded = Math.round(rating || 0);
  switch (rounded) {
    case 5:
      return "text-green-700 fill-green-700";
    case 4:
      return "text-green-600 fill-green-600";
    case 3:
      return "text-green-500 fill-green-500";
    case 2:
      return "text-green-400 fill-green-400";
    case 1:
      return "text-green-300 fill-green-300";
    default:
      return "text-muted-foreground";
  }
};
